import { deviceType } from "../components/Helper";

export interface Key {
    [key: string]: any
}

export const colors = ["bg-blue", "bg-green", "bg-yellow"];

export const processData = (props: any) => {
    const { type, meta, mcuMeta, extMeta, setRowIds, mcu, ext,mcuVersion,notesKey } = props
    const arr: Key[] = [];
    const gid: any = [];
    const id: any = [];
    let data = 0;
    const mcuData = mcuMeta[mcu][mcuVersion];
    const extData = extMeta[ext];
    let color = colors[0];
    const dType: any = deviceType
    Object.keys(extData).forEach((ex) => {
        Object.keys(extData[ex]).forEach((b, idx) => {
            if (gid.indexOf(ex) === -1) {
                gid.push(ex);
                id.push(data);
            }
            if (gid.indexOf(ex) > - 1) { color = colors[gid.indexOf(ex)] }
            data++;

            let deviceKey = b;
            let temp: any = {};
            if (dType[type] === deviceType.CNANO)
                deviceKey = meta?.touchAdapter[ex][b]

            if (mcuData[ex] !== undefined) {
                temp = { ...temp, pin: b, adapter: deviceKey, function: meta.function[type][ex][b], mcuInfo: mcuData[ex][deviceKey]?.data, extData: extData[ex][b]?.data, note: mcuData[ex][dType[type]===deviceType.CNANO?meta?.touchAdapter[ex][b]:b]?.note[notesKey] ?? "--", color }
                if (type === deviceType.XPRO && temp?.adapter)
                    delete temp.adapter
                arr.push(temp)
            }
        })
    })

    if (!mcuData["EXT2"] || !extData["EXT2"]) {
        let extKey = extData["EXT2"] ? "EXT2" : "EXT1";
        Object.keys(extData[extKey]).forEach((b, idx) => {
            const ex = "EXT2";
            let note = ""
            if (gid.indexOf(ex) === -1) {
                gid.push(ex);
                id.push(data);
            }
            if (gid.indexOf(ex) > - 1) { color = colors[gid.indexOf(ex)] }
            data++;
            let mcuInfo = "";
            let deviceKey = b;
            let temp = {};
            if (dType[type] === deviceType.CNANO)
                deviceKey = meta?.touchAdapter[ex][b]

            if (mcuData["EXT1"] && mcuData["EXT1"][deviceKey] && dType[type]===deviceType.CNANO) {
                mcuInfo = mcuData["EXT1"][deviceKey]?.data
                note = mcuData["EXT1"][meta?.touchAdapter[ex][b]]?.note[notesKey]??"--"
            }else if(mcuData["EXT2"] && mcuData["EXT2"][deviceKey] && dType[type]===deviceType.XPRO){
                mcuInfo = mcuData["EXT2"][deviceKey]?.data
                note = mcuData["EXT2"][meta?.touchAdapter[ex][b]]?.note[notesKey]??"--"
            }
            temp = { pin: b, adapter: deviceKey, function: meta.function[type][ex][b], mcuInfo, extData: extData[extKey][b]?.data, note, color }
            arr.push(temp)
        })
    }
        setRowIds(id)
    return arr;
};